  export const ResourcesList = [
  {
    title: 'Revenue & Profitability Calculator',
    href: '/free-resources/revenue-profitability-calculator',
    slug:'revenue-profitability-calculator',
    description: 'This free calculator shows you how much you need to make and how much you can spend in order to pay yourself a desired salary, your liabilities and estimated tax, while still growing your business',
    thumbnail: '/sheets-icon.png',
    imageUrl: '/downloads/revenue-profit-calc-ss.png',
    sheetViewUrl: 'https://docs.google.com/spreadsheets/d/1J_L9XJMiMFiBB-_f5T0umqjMRVDB6Z_oxU8PKzxnYCs',
    sheetCopyUrl: 'https://docs.google.com/spreadsheets/d/1J_L9XJMiMFiBB-_f5T0umqjMRVDB6Z_oxU8PKzxnYCs/copy',
  },
  {
    title: 'Deferred Revenue Calculator',
    href: '/free-resources/deferred-revenue-calculator',
    slug:'deferred-revenue-calculator',
    description: 'This deferred revenue calculator shows you how much cash you collect, earn, and defer over a 3 year period when goods or services are paid for in advance. Common examples of deferred revenue are subscription revenue or retainers.',
    thumbnail: '/sheets-icon.png',
    imageUrl: '/downloads/defferred-rev.png',
    sheetViewUrl: 'https://docs.google.com/spreadsheets/d/1IktLBHYqAbT_aeswkfc-u3dFqIAni1vw6KuN8ebzJOI',
    sheetCopyUrl: 'https://docs.google.com/spreadsheets/d/1IktLBHYqAbT_aeswkfc-u3dFqIAni1vw6KuN8ebzJOI/copy',
  },
  {
    title: 'Recurring Revenue Calculator',
    href: '/free-resources/recurring-revenue-calculator',
    slug:'recurring-revenue-calculator',
    description: 'The recurring revenue calculator projects ARR/MRR as well as new and recurring clients while taking into account churn and expansion. This is an essential tool for a recurring revenue based business.',
    thumbnail: '/sheets-icon.png',
    imageUrl: '/downloads/recurring-rev.png',
    sheetViewUrl: 'https://docs.google.com/spreadsheets/d/1tpYvALkcAMoVapnKpBpbOlXLyNjr5NtJQnQS_WkSFMo',
    sheetCopyUrl: 'https://docs.google.com/spreadsheets/d/1tpYvALkcAMoVapnKpBpbOlXLyNjr5NtJQnQS_WkSFMo/copy',
  },
  {
    title: '13 Week Cash Flow Calculator',
    href: '/free-resources/13wk-cash-flow-calculator',
    slug:'13wk-cash-flow-calculator',
    description: 'The 13-week cash flow calculator is meant for businesses who are at high risk of running out of cash. This allows you to plan expenses and revenue down to the day in order to stay cash flow positive.',
    thumbnail: '/sheets-icon.png',
    imageUrl: '/downloads/13-week-cash-flow.png',
    sheetViewUrl: 'https://docs.google.com/spreadsheets/d/1vPbdRmeP4NBvjSCh2Qd71UKbGPI7YXZRzhv2G5u1xiA',
    sheetCopyUrl: 'https://docs.google.com/spreadsheets/d/1vPbdRmeP4NBvjSCh2Qd71UKbGPI7YXZRzhv2G5u1xiA/copy',
  },
  {
    title: 'Income Statement Generator',
    href: '/free-resources/income-statment-generator',
    slug:'income-statment-generator',
    description: 'This tool allows business owners to easily create a P&L. It is inteneded for those just starting out or independent contractors who do not need to outsource their accounting.',
    thumbnail: '/sheets-icon.png',
    imageUrl: '/downloads/income-statement.png',
    sheetViewUrl: 'https://docs.google.com/spreadsheets/d/135uSUuc8N5ITtv3I9Hdj9Tg5JeneQm5fA8l4MdUaMas',
    sheetCopyUrl: 'https://docs.google.com/spreadsheets/d/135uSUuc8N5ITtv3I9Hdj9Tg5JeneQm5fA8l4MdUaMas/copy',
  },
  {
    title: 'Pinto\'s Standard Chart of Accounts',
    href: '/free-resources/standard-chart-of-accounts',
    slug:'standard-chart-of-accounts',
    description: 'This tool is a great guide to setting up your Income Statement and Balacne Sheet. Managing a Chart of Accounts can be confusing and overwhelming and this guide shows you what accounts you need without all the extras! This is what we use for new businesses.',
    thumbnail: '/sheets-icon.png',
    imageUrl: '/downloads/chart-of-accounts.png',
    sheetViewUrl: 'https://docs.google.com/spreadsheets/d/19fsH248mulevBGS0V8knPFnFtVksqsemPM7WuHRfsyw',
    sheetCopyUrl: 'https://docs.google.com/spreadsheets/d/19fsH248mulevBGS0V8knPFnFtVksqsemPM7WuHRfsyw/copy',
  },


  {
    title: 'Pinto Amortization Schedule',
    href: '/free-resources/pinto-amortization-schedule',
    slug:'pinto-amortization-schedule',
    description: "This calculator is great for analyzing a new loan or determining how extra principal payments affect your overall loan. Quickly calculate your monthly payments with different variables and see how much you'll save if you pay down extra principal.",
    thumbnail: '/sheets-icon.png',
    imageUrl: '/downloads/amortization.png',
    sheetViewUrl: 'https://docs.google.com/spreadsheets/d/1FMF8dTX7l8a53qFapa86IsymqiLY7BpSnJLn8vecXGU',
    sheetCopyUrl: 'https://docs.google.com/spreadsheets/d/1FMF8dTX7l8a53qFapa86IsymqiLY7BpSnJLn8vecXGU/copy'
  },

  {
    title: 'Pinto Depreciation Calculator',
    href: '/free-resources/deprecation',
    slug:'deprecation',
    description: 'This calculator manages the itemization of your depreciable assets. You can track units on hand, accumulated depreciation, and get various totals to enter into your accounting software. This calculator is the easiest way to manage straight-line depreciation!',
    thumbnail: '/sheets-icon.png',
    imageUrl: '/downloads/depreciation.png',
    sheetViewUrl: 'https://docs.google.com/spreadsheets/d/1mqsmnq1YsMBBQwA1ptUzikIqGzfpwPcCbg656UNzdBQ',
    sheetCopyUrl: 'https://docs.google.com/spreadsheets/d/1mqsmnq1YsMBBQwA1ptUzikIqGzfpwPcCbg656UNzdBQ/copy',
  },
  {
    title: 'Pinto Subscription Tracker',
    href: '/free-resources/subscription-tracker',
    slug:'subscription-tracker',
    description: 'This document not only tracks all the monthly and annual subscriptions you pay for but also allows for better headcount planning. Quickly understand your monthly subscription costs, cut the unnecessary expenses, and understand the subscription cost of hiring a new employee or contractor.',
    thumbnail: '/sheets-icon.png',
    imageUrl: '/downloads/subscription-tracker.png',
    sheetViewUrl: 'https://docs.google.com/spreadsheets/d/14jKoElDkFOOPLjkgPWnAMDB-BciRZzFSeOFNTnTMxwQ',
    sheetCopyUrl: 'https://docs.google.com/spreadsheets/d/14jKoElDkFOOPLjkgPWnAMDB-BciRZzFSeOFNTnTMxwQ/copy',
  },
  {
    title: 'Pinto Home Office Calculator',
    href: '/free-resources/home-office-calculator',
    slug:'home-office-calculator',
    description: 'This calculator tracks all of your home office expenses throughout the year so you can either accurately reimburse yourself or maximize your tax dedcutions from your home office.',
    thumbnail: '/sheets-icon.png',
    imageUrl: '/downloads/home-office-screenshot.png',
    sheetViewUrl: 'https://docs.google.com/spreadsheets/d/1AbFnaJDEDVJY_DkX5LYT_RXSQNdTdzHfFnROpS5i3kY',
    sheetCopyUrl: 'https://docs.google.com/spreadsheets/d/1AbFnaJDEDVJY_DkX5LYT_RXSQNdTdzHfFnROpS5i3kY/copy',
  },
]